/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./OrgSignup.css";
import { simpleFetch } from "../../restWrapper";
import { renderErrorMsg } from "../../assets/component/renderErrorMsg.js";
import errorMsg from "../../assets/json/errMsg.json";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { renderOrgLanguageSelector } from "../../assets/component/renderOrgLanguageSelector.js";
import { PLATFORM } from "../../config";

class OrgSignup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      username: "",
      errorMsg: "",
      language: this.props.language,
    };

    this.handleUsername = this.handleUsername.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleUsername(e) {
    this.setState({
      username: e.target.value,
    });
  }

  handleSubmit(e) {
    if (!this.state.username) {
      this.setState({
        errorMsg: errorMsg[this.state.language].loginErr.loginEmailErr,
      });
      return;
    }
    this.setState({
      loading: true,
    });
    simpleFetch("/organizations/username/", "POST", {
      username: this.state.username,
      expectedType: "organization",
      platform: PLATFORM,
    }).then((res) => {
      this.setState({
        loading: false,
      });
      switch (res.status) {
        case 403:
          this.setState({
            errorMsg: errorMsg[this.state.language].loginErr.acVerify,
          });
          break;
        case 404:
          this.props.history.push({
            pathname: "/OrgAgreement",
            state: {
              username: this.state.username,
            },
          });
          break;
        case 422:
          this.setState({
            errorMsg: errorMsg[this.state.language].loginErr.loginEmailErr,
          });
          break;
        case 204:
          this.props.history.push({
            pathname: "/OrgLoginPassword",
            state: {
              username: this.state.username,
            },
          });
          break;
        case 200:
          // Platform mismatch - account exists on different platform
          if (res.body.platformMismatch) {
            this.setState({
              errorMsg: errorMsg[this.state.language].loginErr.platformMismatch,
            });
          }
          break;
        default:
          break;
      }
    });
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="OrgSignup-view">
          <div className="OrgSignup-loadingprompt">
            <this.props.RenderFullPageLoading />
          </div>
        </div>
      );
    }

    const languageObj = this.props.languageObj;

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        this.handleSubmit();
      }
    };

    return (
      <div className="OrgSignup-view">
        <div className="OrgSignup-CheckPlusLogo" />
        <div className="OrgSignup-prompt">

          <div className="OrgSignup-topContainer">
            <Link to={"/"}>
              <div className="OrgSignup-backContainer">
                <div className="OrgSignup-backBtn" />
              </div>
            </Link>

            <div className="OrgSignup-loginText">{languageObj.loginText}</div>

            <div className="OrgSignup-languageBar">
              <div className="OrgSignup-globe" />
              <div className="OrgSignup-languageSelector">
                {renderOrgLanguageSelector()}
              </div>
            </div>

          </div>

          <div className="OrgSignup-loginContainer">

            
            <div className="OrgSignup-text">{languageObj.text}</div>

            <div className="OrgSignup-inputFieldContainer">
              <div className="OrgSignup-inputContainerLeft">
                <input
                  type="text"
                  value={this.state.username}
                  onChange={this.handleUsername}
                  className="OrgSignup-inputField"
                  placeholder={languageObj.inputField}
                  onKeyDown={handleKeyDown}
                />
              </div>
              <div className="OrgSignup-inputContainerRight">
                <div onClick={this.handleSubmit} className="OrgSignup-nextBtn">
                  <div className="OrgSignup-nextIcn" />
                </div>
              </div>
            </div>

            {renderErrorMsg(this.state.errorMsg)}
          </div>
        </div>
        <div className="OrgSignup-awardsOuterContainer">
          <div className="OrgSignup-trophyContainer">
            <div className="OrgSignup-trophyIcn" />
            <div className="OrgSignup-trophyTxt">{languageObj.awardTxt}</div>
          </div>

          <div className="OrgSignup-awardsContainer">
            <div className="OrgSignup-awards" />
          </div>
        </div>
        
      </div>
    );
  }
}
OrgSignup.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
};

export default OrgSignup;
